// ############################ Require packages here ############################
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// ############################ Require files here ###############################

import './resources.scss';
import ScheduleForm from '../scheduleForm';
import RelatedResources from '../relatedResources';
import ShareUrl from './shareUrl';
import FactsheetModal from '../Industries/factsheetModal';


export default function Features() {

    const navigate = useNavigate();
    return (
        <div className='seq-reports-view'>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <title>Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM</title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Sequretek launches its latest SaaS innovation: Percept CTEM" />
                <meta name="keywords" content="Sequretek, Gartner, CTEM, Percept CTEM, Cybersecrity, Continuous Threat Exposure Management, Asset" />
                <meta property="og:title" content="Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM" />
                <meta property="og:description" content="Sequretek launches its latest SaaS innovation: Percept CTEM" />
            </Helmet>
            {/* section 1 BANNER */}
            <div className='container contain-width mt-5'>
                <div className='breadcrumb pe-0 ps-0'>
                    <ul>
                        <li><span onClick={() => navigate('/resources-hub')}>Resources  </span>
                            <span onClick={() => navigate('/resources-hub', { state: { type: 'spotlight' } })}>{' > '} Spotlight</span>
                            <span>{' > '}Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM</span>
                        </li>
                    </ul>



                </div>
                {/* section 2 DISCRIPTION */}
                <div className='seq-report-view'>
                    <div className='blog-div'>
                        <h3>Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM</h3>
                        <div className='text-end'>
                            <button type="submit" onClick={() => {
                                window.location.href = "/press/Sequretek-Ensures-Every-Asset-Matters-with-the-Launch-of-Percept-CTEM"
                            }} className='input-submit-btn btn btn-danger' >Read Press</button>
                        </div>
                        <p>25-JUN-2025</p>
                        <div className='blog-body'>
                            <img src='/images/blog-images/Percept CTEM_Spotlight.png' width={'100%'} height={420} alt='' />

                            <p><strong>New York, June 25, 2025 - </strong>Sequretek, a global leader in AI-powered cybersecurity solutions, today launched its latest SaaS innovation: Percept CTEM. This groundbreaking platform aims to eliminate surprises by offering complete visibility into every asset within an organization, providing a proactive and predictive approach to managing risks.</p>

                            <p>Guided by the philosophy that every asset matters, Percept CTEM ensures continuous threat exposure management across the entire digital attack surface, recognizing that even a small, seemingly insignificant asset can be the entry point for a costly breach.</p>

                            <p>In today’s evolving cybersecurity landscape, where threats are becoming increasingly sophisticated, organizations must recognize that no asset is too small to be ignored. Attackers exploit even the smallest vulnerabilities, and a breach can occur when an asset is overlooked. According to <a target='_blank' href='https://www.gartner.com/en/articles/how-to-manage-cybersecurity-threats-not-episodes'>Gartner</a>, organizations that base their security investments on a continuous exposure management program by 2026 will be three times less likely to experience a breach.</p>

                            <p>Purpose-built to stay ahead of cyber adversaries, Percept CTEM promises “Every Asset. Every Moment. No Surprises,” giving organizations the power to proactively manage risk. Enhanced with AI, it prioritizes risk based on business context. The platform identifies vulnerabilities before they evolve into threats and offers automated mitigation recommendations. Unlike traditional security tools that may only focus on high-value targets, Percept CTEM treats every asset, critical or not, with equal vigilance. It understands that every breach starts somewhere, and that one entry point can disrupt business operations.</p>

                            <p>“What organizations often discover too late is that a low-priority asset can be the backdoor for a major breach,” said <a target='_blank' href='https://www.linkedin.com/in/anand-naik-4726bb15?originalSubdomain=in'>Anand Naik</a>, CEO & Co-Founder of Sequretek. “Percept CTEM eliminates these surprises by continuously mapping and validating security across all systems, providing the peace of mind that no asset, no matter how small, is never left vulnerable.”</p>

                            <p>Percept CTEM integrates seamlessly with third-party tools and Sequretek’s Percept security suite, including Percept XDR, NG SIEM, Percept Identity, Percept EDR, and Percept Compliance Manager, serving as an intelligent overlay that contextualizes data from existing tools. From asset discovery to automated remediation, it’s security without blind spots.</p>

                            <h4>About Sequretek</h4>
                            <p><a target='_blank' href='https://www.sequretek.com/'>Sequretek</a> is a global cybersecurity company offering AI-powered, cloud-native solutions that simplify security. Sequretek’s Percept solution suite delivers defense-in-depth and defense-in-breadth. It coexists with and complements existing technologies, allowing customers and partners to consolidate at their own pace. Sequretek's AI technologies, coupled with robust processes and expert teams, protect organizations' IT assets from cyberthreats, while helping them comply with regulatory standards. Percept solutions are reliable, simple, and adaptive, with a low cost of ownership, empowering customers to confidently grow in the digital space.</p>

                            <h4>Media Contacts:</h4>
                            <p><a target='_blank' href='sequretek@thegutenberg.com'>Gutenberg: sequretek@thegutenberg.com</a></p>

                        </div>
                    </div>
                </div>
                <ShareUrl
                    details={{ title: 'Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM', url: 'https://www.sequretek.com/resources/features/Sequretek-Ensures-Every-Asset-Matters-with-the-Launch-of-Percept-CTEM ' }}
                />
                {/* section 3 RELATED RESOURCES */}
                <div className='seq-resources'>
                    <div className={window.innerWidth > 767 ? 'ps-0' : 'ps-3'}>
                        <h4>Related resources</h4>
                        <div className='row ms-0 me-0'>
                            <div className='col-md-12 ps-0'>
                                <div className={window.innerWidth > 767 ? 'row ' : 'row flex-nowrap overflow-auto ms-0'}>
                                    <RelatedResources
                                        page='resources'
                                        type='spotlight'
                                        title='Sequretek Ensures Every Asset Matters with the Launch of Percept CTEM'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section 4 SCHEDULE DEMO FORM */}
            <div className='seq-forms'>
                <div className='container '>
                    <div className="insurance-partseven">
                        <ScheduleForm
                            bg={'/images/bg-img22.svg'}
                            mobilebg={'/images/bg-img23.png'}
                            page='resources'
                            text={`Don't wait until it's too late. Strengthen your cyber defences today with Sequretek. Contact us to schedule a demo and learn how our cybersecurity solutions can arm your enterprise against evolving threats.`}
                        />
                    </div>
                </div>
            </div>



        </div>
    )
}